export default "__VITE_ASSET__BeyENdUf__"